import { useTexture } from '@react-three/drei'
import React, { useMemo } from 'react'
import * as THREE from 'three'
import { usePlane } from '@react-three/cannon'

const Plane = ({sceneImg, sceneSize}) => {

    const [ref] = usePlane(() => ({ rotation: [-Math.PI / 2, 0, 0], position : [0,0,0] }))

    const map = useTexture(sceneImg)

    return (
        <>
                <mesh
                    ref={ref} 
                    rotation={[-Math.PI/2, 0, 0]} 
                >
                    <planeBufferGeometry args={sceneSize}/>
                    <meshBasicMaterial map={map} side={THREE.DoubleSide} visible={true} transparent opacity={1} />
                </mesh>
        </>
    )
}

export default Plane
